export const useHojaPesadorCalculations = () => {
  // Calcular PPR (Peso Promedio por Racimo)
  const calcularPPR = (pesoFruta, cantidadRacimos) => {
    if (!cantidadRacimos || cantidadRacimos === 0) return 0;
    return (parseFloat(pesoFruta) / parseInt(cantidadRacimos)).toFixed(2);
  };

  // Calcular Peso Neto
  const calcularPesoNeto = (pesoFruta, pesoRechazado) => {
    return (parseFloat(pesoFruta) - parseFloat(pesoRechazado || 0)).toFixed(2);
  };

  // Calcular % Coyol
  const calcularPorcentajeCoyol = (pesoCoyol, pesoFruta) => {
    if (!pesoFruta || parseFloat(pesoFruta) === 0) return 0;
    return ((parseFloat(pesoCoyol || 0) / parseFloat(pesoFruta)) * 100).toFixed(2);
  };

  // Calcular PPS (Peso Promedio Saco)
  const calcularPPS = (pesoRechazado, cantidadSacos) => {
    if (!cantidadSacos || parseInt(cantidadSacos) === 0) return 0;
    return (parseFloat(pesoRechazado || 0) / parseInt(cantidadSacos)).toFixed(2);
  };

  // Calcular Peso Bruto
  const calcularPesoBruto = (pesoFruta, pesoRechazado) => {
    return (parseFloat(pesoFruta) + parseFloat(pesoRechazado || 0)).toFixed(2);
  };

  // Calcular porcentajes de control de calidad
  const calcularPorcentaje = (cantidad, racimosEvaluados) => {
    if (!racimosEvaluados || parseInt(racimosEvaluados) === 0) return 0;
    return ((parseFloat(cantidad || 0) / parseInt(racimosEvaluados)) * 100).toFixed(2);
  };

  // Recalcular todos los porcentajes cuando cambia racimos evaluados
  const recalcularPorcentajes = (formData) => {
    const racimosEvaluados = parseInt(formData.racimos_evaluados) || 0;
    
    if (racimosEvaluados === 0) {
      return {
        porcentaje_pasados: 0,
        porcentaje_pinzote: 0,
        porcentaje_verdes: 0,
        porcentaje_sobre_maduros: 0
      };
    }

    return {
      porcentaje_pasados: calcularPorcentaje(formData.pasados, racimosEvaluados),
      porcentaje_pinzote: calcularPorcentaje(formData.pinzote, racimosEvaluados),
      porcentaje_verdes: calcularPorcentaje(formData.verdes, racimosEvaluados),
      porcentaje_sobre_maduros: calcularPorcentaje(formData.sobre_maduros, racimosEvaluados)
    };
  };

  // Calcular tiempo en planta
  const calcularTiempoEnPlanta = (horaIngreso, horaSalida) => {
    if (!horaIngreso || !horaSalida) return 'N/A';
    
    try {
      const [horaIng, minIng] = horaIngreso.split(':').map(Number);
      const [horaSal, minSal] = horaSalida.split(':').map(Number);
      
      let totalMinutos = (horaSal * 60 + minSal) - (horaIng * 60 + minIng);
      
      if (totalMinutos < 0) {
        totalMinutos += 24 * 60;
      }
      
      const horas = Math.floor(totalMinutos / 60);
      const minutos = totalMinutos % 60;
      
      return `${horas}h ${minutos}m`;
    } catch (error) {
      return 'N/A';
    }
  };

  return {
    calcularPPR,
    calcularPesoNeto,
    calcularPorcentajeCoyol,
    calcularPPS,
    calcularPesoBruto,
    calcularPorcentaje,
    recalcularPorcentajes,
    calcularTiempoEnPlanta
  };
};
